// extracted by mini-css-extract-plugin
export var arbiterBadgeContainer = "_1g-0";
export var colorSwatch = "_1g-5";
export var compactSwatch = "_1g-7";
export var fillWidth = "_1g-4";
export var iconButton = "_1g-2";
export var iconWrapper = "_1g-3";
export var shadow = "_1g-6";
export var xs = "_1g-1";